// extracted by mini-css-extract-plugin
export default {"breakpointSm":"720","breakpointMd":"1250","breakpointLg":"1650"};